export const pattern20Data = [
  {
    koreanChunks: ["관리자는", "(현재) 검토합니다", "판매 보고서를 매일 아침"],
    englishChunks: ["The manager", "reviews", "the sales report every morning"],
    fullEnglish: "The manager reviews the sales report every morning.",
    additionalExplanation:
      "주어가 단수형(the manager) , 단수 동사(reviews)를 사용합니다.",
  },
  {
    koreanChunks: ["기계는", "(현재) 작동합니다", "24시간 하루 종일"],
    englishChunks: ["The machine", "operates", "24 hours a day"],
    fullEnglish: "The machine operates 24 hours a day.",
    additionalExplanation:
      "주어가 단수형(the machine), 단수 동사(operates)를 사용합니다.",
  },
  {
    koreanChunks: ["정책은", "(현재) 적용됩니다", "모든 신입 직원들에게"],
    englishChunks: ["The policy", "applies", "to all new employees"],
    fullEnglish: "The policy applies to all new employees.",
    additionalExplanation:
      "주어가 단수형(the policy), 단수 동사(applies)를 사용합니다.",
  },
  {
    koreanChunks: ["소식은", "(현재) 전파됩니다 빠르게", "작은 사무실에서"],
    englishChunks: ["News", "travels quickly", " in a small office"],
    fullEnglish: "News travels quickly in a small office.",
    additionalExplanation:
      "주어가 단수형(news), 단수 동사(travels)를 사용합니다. 'News'는 단수 취급하는 명사입니다.",
  },
  {
    koreanChunks: ["증거가", "(현재) 제시되었습니다", "회의 중에"],
    englishChunks: ["Evidence", "was presented", "during the meeting"],
    fullEnglish: "Evidence was presented during the meeting.",
    additionalExplanation:
      "주어가 단수형(evidence), werer가 아닌 was가 옵니다. 'Evidence'는 단수 취급하는 명사입니다.",
  },
  {
    koreanChunks: ["연구가", "(현재) 진행되는 중입니다", "이 주제에 대해"],
    englishChunks: ["Research", "is being conducted", "on the topic"],
    fullEnglish: "Research is being conducted on the topic.",
    additionalExplanation:
      "주어가 단수형(research), 단수 취급하여 is를 사용합니다. 'Research'는 단수 취급하는 명사입니다.",
  },
  {
    koreanChunks: ["진전이", "(현재) 만들어졌다.", "프로젝트에서"],
    englishChunks: ["Progress", "has been made", "on the project"],
    fullEnglish: "Progress has been made on the project.",
    additionalExplanation:
      "주어가 단수형(progress), 단수 취급하여 has를 사용합니다. 'Progress'는 단수 취급하는 명사입니다.",
  },
  {
    koreanChunks: ["피드백은", "(현재) 권장됩니다", "교육 세션 이후에"],
    englishChunks: ["Feedback", "is encouraged", "after the training session"],
    fullEnglish: "Feedback is encouraged after the training session.",
    additionalExplanation:
      "주어가 단수형(feedback), 단수 취급하여 is를 사용합니다. 'Feedback'은 단수 취급하는 명사입니다.",
  },
  {
    koreanChunks: ["감독관으로부터", "승인이", "(현재) 필요합니다"],
    englishChunks: ["Approval", "is needed", "from the supervisor"],
    fullEnglish: "Approval is needed from the supervisor.",
    additionalExplanation:
      "주어가 단수형(approval), 단수 취급하여 is를 사용합니다. 'Approval'은 단수 취급하는 명사입니다.",
  },
  {
    koreanChunks: ["협조가", "(현재) 감사되어집니다", "이 전환동안"],
    englishChunks: ["Cooperation", "is appreciated", "during the transition"],
    fullEnglish: "Cooperation is appreciated during the transition.",
    additionalExplanation:
      "주어가 단수형(cooperation), 단수 취급하여 is를 사용합니다. 'Cooperation'은 단수 취급하는 명사입니다.",
  },
  {
    koreanChunks: ["행동이", "(현재) 모니터링됩니다", "직장에서"],
    englishChunks: ["Behavior", "is monitored", "in the workplace"],
    fullEnglish: "Behavior is monitored in the workplace.",
    additionalExplanation:
      "주어가 단수형(behavior), 단수 취급하여 is를 사용합니다. 'Behavior'는 단수 취급하는 명사입니다.",
  },
  {
    koreanChunks: ["상품이", "(현재) 전시되어 있습니다", "입구 근처에"],
    englishChunks: ["Merchandise", "is displayed", "near the entrance"],
    fullEnglish: "Merchandise is displayed near the entrance.",
    additionalExplanation:
      "주어가 단수형(merchandise), 단수 취급하여 is를 사용합니다. 'Merchandise'는 단수 취급하는 명사입니다.",
  },
  {
    koreanChunks: ["기계류가", "(현재)유지보수됩니다", "정기적으로"],
    englishChunks: ["Machinery", "is maintained", "regularly"],
    fullEnglish: "Machinery is maintained regularly.",
    additionalExplanation:
      "주어가 단수형(machinery), 단수 취급하여 is를 사용합니다. 'Machinery'는 단수 취급하는 명사입니다.",
  },
  {
    koreanChunks: ["가구가", "(과거에) 배달되었습니다", "오늘 아침에"],
    englishChunks: ["Furniture", "was delivered", "this morning"],
    fullEnglish: "Furniture was delivered this morning.",
    additionalExplanation:
      "주어가 단수형(furniture), 단수 취급하여 was를 사용합니다. 'Furniture'는 단수 취급하는 명사입니다.",
  },
  {
    koreanChunks: ["문서가", "(현재) 필요합니다", "환급을 위해"],
    englishChunks: ["Documentation", "is necessary", "for reimbursement"],
    fullEnglish: "Documentation is necessary for reimbursement.",
    additionalExplanation:
      "주어가 단수형(documentation), 단수 취급하여 is를 사용합니다. 'Documentation'은 단수 취급하는 명사입니다.",
  },
  {
    koreanChunks: ["동의가", "(현재) 요구됩니다", "진행하기 전에"],
    englishChunks: ["Consent", "is required", "before proceeding"],
    fullEnglish: "Consent is required before proceeding.",
    additionalExplanation:
      "주어가 단수형(consent), 단수 취급하여 is를 사용합니다. 'Consent'는 단수 취급하는 명사입니다.",
  },
  {
    koreanChunks: ["서신이", "(현재) 전달됩니다", "인사부로"],
    englishChunks: ["Correspondence", "is directed", "to the HR department"],
    fullEnglish: "Correspondence is directed to the HR department.",
    additionalExplanation:
      "주어가 단수형(correspondence), 단수 취급하여 is를 사용합니다. 'Correspondence'는 단수 취급하는 명사입니다.",
  },
  {
    koreanChunks: ["누군가", "확인해야 합니다", "예약을", "오후 3시까지"],
    englishChunks: [
      "Someone",
      "needs to confirm",
      "the reservation",
      "by 3 p.m.",
    ],
    fullEnglish: "Someone needs to confirm the reservation by 3 p.m.",
    additionalExplanation:
      "누군가(someone)는 단수 취급합니다. 그래서 need라고 하지 않고 needs라고 말합니다.",
  },
  {
    koreanChunks: ["누군가가", "(현재)남겼습니다", "소포를", "접수처에"],
    englishChunks: ["Someone", "has left", "a package", "at the front desk"],
    fullEnglish: "Someone has left a package at the front desk.",
    additionalExplanation:
      "누군가(someone)는 단수 취급합니다. 그래서 have가 아니라 has라고 해야 합니다.",
  },

  {
    koreanChunks: ["누구든지", "참석하실 수 있습니다", "워크숍에"],
    englishChunks: ["Anyone", "is welcome to attend", "the workshop"],
    fullEnglish: "Anyone is welcome to attend the workshop.",
    additionalExplanation:
      "누구든지(anyone)는 단수 취급합니다. 그래서 are가 아니라 is를 사용합니다.",
  },
  {
    koreanChunks: [
      "누구나",
      "그.. .필요한 도움이",
      "권장됩니다 문의하도록 헬프데스크로",
    ],
    englishChunks: [
      "Anybody",
      "who needs assistance",
      "is encouraged to contact the help desk",
    ],
    fullEnglish:
      "Anybody who needs assistance is encouraged to contact the help desk.",
    additionalExplanation:
      "누구나(anybody)는 단수 취급합니다. 그래서 are가 아니라 is를 사용합니다.",
  },
  {
    koreanChunks: ["모든 사람이", "요구됩니다", "완료하도록 설문조사를"],
    englishChunks: ["Everyone", "is required", "to complete the survey"],
    fullEnglish: "Everyone is required to complete the survey.",
    additionalExplanation:
      "모든 사람(everyone)은 단수 취급합니다. 그래서 are가 아니라 is를 사용합니다. 모든 사람을 하나로 묶어 하나로 여긴다 생각하면 쉽습니다.",
  },
  {
    koreanChunks: ["모든 사람이", "받습니다", "디지털 사본을", "핸드북의"],
    englishChunks: [
      "Everybody",
      "receives",
      "a digital copy",
      "of the handbook",
    ],
    fullEnglish: "Everybody receives a digital copy of the handbook.",
    additionalExplanation:
      "모든 사람(everybody)은 단수 취급합니다. 그래서 receive가 아니라 receives를 사용합니다. everyone과 마찬가지로 집합적으로 하나로 취급합니다.",
  },
  {
    koreanChunks: ["아무도", "모릅니다", "정확한 이유를", "지연의"],
    englishChunks: ["No one", "knows", "the exact reason", "for the delay"],
    fullEnglish: "No one knows the exact reason for the delay.",
    additionalExplanation:
      "아무도(no one)는 단수 취급합니다. 그래서 know가 아니라 knows를 사용합니다. 부정적인 의미의 단수 대명사로 연결된 동사에 부정을 붙여 해석합니다 knows -> don't know ",
  },
  {
    koreanChunks: ["아무도", "허용되지 않습니다", "입장이", "배지 없이"],
    englishChunks: ["Nobody", "is allowed", "to enter", "without a badge"],
    fullEnglish: "Nobody is allowed to enter without a badge.",
    additionalExplanation:
      "아무도(nobody)는 단수 취급합니다. 그래서 are가 아니라 is를 사용합니다. 부정적인 의미의 단수 대명사로, 문장에서 단수 동사형태와 함께 사용됩니다.이때 동사를 부정으로 바꿔서 해석해야 합니다.",
  },
  {
    koreanChunks: ["무언가", "잘못된 것 같습니다", "로그인 시스템에"],
    englishChunks: ["Something", "seems wrong", "with the login system"],
    fullEnglish: "Something seems wrong with the login system.",
    additionalExplanation:
      "무언가(something)는 단수 취급합니다. 그래서 seem이 아니라 seems를 사용합니다. 불특정한 것을 가리키는 단수 대명사입니다.",
  },
  {
    koreanChunks: ["만약 무언가가 잘못되면", "전화하세요", "내선 0번으로"],
    englishChunks: ["If anything goes wrong", "please call", "extension 0"],
    fullEnglish: "If anything goes wrong, please call extension 0.",
    additionalExplanation:
      "무언가(anything)는 단수 취급합니다. 그래서 go가 아니라 goes를 사용합니다. 여기서는 조건절에서 불특정한 것을 가리키는 단수 대명사로 사용되었습니다.",
  },
  {
    koreanChunks: ["모든 것이", "준비되어 있습니다", "제품 출시를 위해"],
    englishChunks: ["Everything", "is ready", "for the product launch"],
    fullEnglish: "Everything is ready for the product launch.",
    additionalExplanation:
      "모든 것(everything)은 단수 취급합니다. 그래서 are가 아니라 is를 사용합니다. 여러 항목을 하나의 전체로 간주하기 때문에 단수 동사와 함께 사용됩니다.",
  },
  {
    koreanChunks: ["아무것도", "변하지 않았습니다", "지난 업데이트 이후"],
    englishChunks: ["Nothing", "has changed", "since the last update"],
    fullEnglish: "Nothing has changed since the last update.",
    additionalExplanation:
      "아무것도(nothing)는 단수 취급합니다. 그래서 have가 아니라 has를 사용합니다. 부정적인 의미의 단수 대명사로,동사 해석시 부정으로 해석해야 합니다.",
  },
  {
    koreanChunks: ["각 직원은", "(현재)받습니다", "보안 배지를", "채용 시"],
    englishChunks: [
      "Each employee",
      "receives",
      "a security badge",
      "upon hiring",
    ],
    fullEnglish: "Each employee receives a security badge upon hiring.",
    additionalExplanation:
      "각(each)은 단수 취급합니다. 그래서 receive가 아니라 receives를 사용합니다. each는 집단 내의 개별 구성원을 하나씩 지칭할 때 사용하는 말입니다.",
  },
  {
    koreanChunks: ["각 부서는", "(현재)제출합니다", "월간 보고서를"],
    englishChunks: ["Each department", "submits", "a monthly report"],
    fullEnglish: "Each department submits a monthly report.",
    additionalExplanation:
      "각(each)은 단수 취급합니다. 그래서 submit이 아니라 submits를 사용합니다. each는 집단 내의 개별 구성원을 하나씩 지칭할 때 사용하는 말입니다.",
  },
  {
    koreanChunks: ["모든 고객은", "(현재)받습니다", "확인 이메일을"],
    englishChunks: ["Every customer", "receives", "a confirmation email"],
    fullEnglish: "Every customer receives a confirmation email.",
    additionalExplanation:
      "모든(every)은 단수 취급합니다. 그래서 receive가 아니라 receives를 사용합니다. every는 집단 내의 모든 개별 구성원을 지칭하지만, 문법적으로는 단수로 취급됩니다.",
  },
  {
    koreanChunks: ["모든 주문은", "(현재)처리됩니다", "24시간 이내에"],
    englishChunks: ["Every order", "is processed", "within 24 hours"],
    fullEnglish: "Every order is processed within 24 hours.",
    additionalExplanation:
      "모든(every)은 단수 취급합니다. 그래서 are가 아니라 is를 사용합니다. every는 집단 내의 모든 개별 구성원을 지칭하지만, 문법적으로는 단수로 취급됩니다. 따라서 수동태 구문에서도 단수형 동사(is processed)가 사용됩니다.",
  },
  {
    koreanChunks: [
      "모든 좌석은",
      "(현재)장착되어 있습니다",
      "충전 포트와 함께",
    ],
    englishChunks: ["Every seat", "is equipped", "with a charging port"],
    fullEnglish: "Every seat is equipped with a charging port.",
    additionalExplanation:
      "모든(every)은 단수 취급합니다. 그래서 are가 아니라 is를 사용합니다. every는 집단 내의 모든 개별 구성원을 지칭하지만, 문법적으로는 단수로 취급됩니다. 따라서 수동태 구문에서도 단수형 동사(is equipped)가 사용됩니다.",
  },
  {
    koreanChunks: [
      "읽는 것은 섦명서를",
      "(현재)도와줍니다",
      "사용자들이",
      "이해하도록 기기를",
    ],
    englishChunks: [
      "Reading the manual",
      "helps",
      "users",
      "understand the device",
    ],
    fullEnglish: "Reading the manual helps users understand the device.",
    additionalExplanation: "동명사구 reading(읽는것)은 단수취급합니다.",
  },
  {
    koreanChunks: ["운영하는 것은 사업을", "(현재)요구합니다", "신중한 계획을"],
    englishChunks: ["Running a business", "requires", "careful planning"],
    fullEnglish: "Running a business requires careful planning.",
    additionalExplanation:
      "동명사구 Running(운영하는 것)은 단수 취급합니다. 그래서 require가 아니라 requires를 사용합니다. 동명사로 시작하는 주어는 문법적으로 단수로 취급됩니다.",
  },
  {
    koreanChunks: [
      "회의가 취소되었다는 것이",
      "(현재)놀라게 합니다",
      "많은 직원들을",
    ],
    englishChunks: [
      "That the meeting was canceled",
      "surprises",
      "many employees",
    ],
    fullEnglish: "That the meeting was canceled surprises many employees.",
    additionalExplanation:
      "명사절(That the meeting was canceled)이 주어로 사용될 때는 단수 취급합니다. 그래서 surprise가 아니라 surprises를 사용합니다. 'that'으로 시작하는 명사절은 하나의 개념이나 사실을 나타내므로 문법적으로 단수로 취급됩니다.",
  },
  {
    koreanChunks: [
      "어떻게 그 시스템이 작동하는지는",
      "(현재)의존합니다",
      "설정에",
    ],
    englishChunks: ["How the system works", "depends", "on the configuration"],
    fullEnglish: "How the system works depends on the configuration.",
    additionalExplanation:
      "명사절(How the system works)이 주어로 사용될 때는 단수 취급합니다. 그래서 depend가 아니라 depends를 사용합니다. 'how'로 시작하는 명사절은 하나의 개념이나 방식을 나타내므로 문법적으로 단수로 취급됩니다.",
  },
  {
    koreanChunks: [
      "제안이 수락될지 여부는",
      "(현재)남아있습니다",
      "불확실하게",
    ],
    englishChunks: ["Whether the proposal is accepted", "remains", "uncertain"],
    fullEnglish: "Whether the proposal is accepted remains uncertain.",
    additionalExplanation:
      "명사절(Whether the proposal is accepted)이 주어로 사용될 때는 단수 취급합니다. 그래서 remain이 아니라 remains를 사용합니다. 'whether'로 시작하는 명사절은 하나의 가능성이나 상황을 나타내므로 문법적으로 단수로 취급됩니다.",
  },
  {
    koreanChunks: [
      "경력과 리더십 역량은",
      "(현재)간주됩니다",
      "필수로",
      "그 직무에",
    ],
    englishChunks: [
      "Experience and leadership skills",
      "are considered",
      "essential",
      "for the role",
    ],
    fullEnglish:
      "Experience and leadership skills are considered essential for the role.",
    additionalExplanation:
      "복수 명사들이 'and'로 연결된 주어(Experience and leadership skills)는 복수 취급합니다. 그래서 'is considered'가 아닌 'are considered'를 사용합니다. 두 개 이상의 명사가 'and'로 연결되면 일반적으로 복수 동사를 사용합니다.",
  },
  {
    koreanChunks: ["프린터와 스캐너는", "(현재)위치해 있습니다", "복사실에"],
    englishChunks: [
      "The printer and the scanner",
      "are located",
      "in the copy room",
    ],
    fullEnglish: "The printer and the scanner are located in the copy room.",
    additionalExplanation:
      "복수 명사들이 'and'로 연결된 주어(The printer and the scanner)는 복수 취급합니다. 그래서 'is located'가 아닌 'are located'를 사용합니다. 두 개 이상의 명사가 'and'로 연결되면 일반적으로 복수 동사를 사용합니다.",
  },
  {
    koreanChunks: [
      "사람들은",
      "종종 잊어버립니다",
      "가져오는 것을 그들의 신분증을 ",
      "사무실에",
    ],
    englishChunks: [
      "People",
      "often forget",
      "to bring their ID cards",
      "to the office",
    ],
    fullEnglish: "People often forget to bring their ID cards to the office.",
    additionalExplanation:
      "복수 명사인 'People'이 주어로 사용되었으므로 forgets가 아니라 복수 동사 형태인 'forget'을 사용합니다. 'People'은 집합적 복수 명사로, 항상 복수 취급됩니다.",
  },
  {
    koreanChunks: [
      "12세 미만의 어린이들은",
      "(현재)받습니다",
      "할인을",
      "입장료에",
    ],
    englishChunks: [
      "Children under 12",
      "receive",
      "a discount",
      "on admission fees",
    ],
    fullEnglish: "Children under 12 receive a discount on admission fees.",
    additionalExplanation:
      "복수 명사인 'Children'이 주어로 사용되었으므로 receives가 아니라 복수 동사 형태인 'receive'를 사용합니다. 'Children'은 'child'의 복수형으로, 복수 취급되어 복수 동사를 사용합니다.",
  },
  {
    koreanChunks: [
      "남성들은",
      "(현재)요구됩니다",
      "착용하도록",
      "정장을",
      "행사에",
    ],
    englishChunks: [
      "Men",
      "are required",
      "to wear",
      "formal attire",
      "to the event",
    ],
    fullEnglish: "Men are required to wear formal attire to the event.",
    additionalExplanation:
      "복수 명사인 'Men'이 주어로 사용되었으므로 'is required'가 아니라 복수 동사 형태인 'are required'를 사용합니다. 'Men'은 'man'의 복수형으로, 복수 취급되어 복수 동사를 사용합니다.",
  },
  {
    koreanChunks: [
      "여성들은",
      "부서 안의",
      "(현재)요청했습니다",
      "더 유연한 근무 시간을",
    ],
    englishChunks: [
      "Women",
      "in the department",
      "have requested",
      "more flexible hours",
    ],
    fullEnglish: "Women in the department have requested more flexible hours.",
    additionalExplanation:
      "복수 명사인 'Women'이 주어로 사용되었으므로 'has requested'가 아니라 복수 동사 형태인 'have requested'를 사용합니다. 'Women'은 'woman'의 복수형으로, 복수 취급되어 복수 동사를 사용합니다.",
  },
  {
    koreanChunks: [
      "기준은",
      "선정을 위한",
      "명확하게 (현재)설명되어 있습니다",
      "지침에",
    ],
    englishChunks: [
      "The criteria",
      "for selection",
      "are clearly outlined",
      "in the guidelines",
    ],
    fullEnglish:
      "The criteria for selection are clearly outlined in the guidelines.",
    additionalExplanation:
      "복수 명사인 'criteria'가 주어로 사용되었으므로 'is outlined'가 아니라 복수 동사 형태인 'are outlined'를 사용합니다. 'Criteria'는 'criterion'의 복수형으로, 복수 취급되어 복수 동사를 사용합니다.",
  },
  {
    koreanChunks: ["동문들은 대학", "종종 (현재)참석합니다", "네트워킹 행사에"],
    englishChunks: [
      "Alumni",
      "of the university",
      "often attend",
      "networking events",
    ],
    fullEnglish: "Alumni of the university often attend networking events.",
    additionalExplanation:
      "복수 명사인 'Alumni'가 주어로 사용되었으므로 'attends'가 아니라 복수 동사 형태인 'attend'를 사용합니다. 'Alumni'는 'alumnus'(남성 졸업생) 또는 'alumna'(여성 졸업생)의 복수형으로, 복수 취급되어 복수 동사를 사용합니다.",
  },
  {
    koreanChunks: ["미디어는", "(현재)보도했습니다 광범위하게", "합병에 대해"],
    englishChunks: ["The media", "have reported extensively", "on the merger"],
    fullEnglish: "The media have reported extensively on the merger.",
    additionalExplanation:
      "집합 명사인 'media'가 주어로 사용되었으므로 'has reported'가 아니라 복수 동사 형태인 'have reported'를 사용합니다. 'Media'는 영어에서 'medium'의 복수형이지만, 집합적 의미로 사용될 때 복수 취급되어 복수 동사를 사용합니다.",
  },

  {
    koreanChunks: ["많은 직원들이", "(현재)참석합니다", "주간 브리핑에"],
    englishChunks: ["Many employees", "attend", "the weekly briefing"],
    fullEnglish: "Many employees attend the weekly briefing.",
    additionalExplanation:
      "복수 명사인 'employees'가 주어로 사용되었으므로 'attends'가 아니라 복수 동사 형태인 'attend'를 사용합니다. 'Many employees'는 복수 명사구로, 복수 취급되어 복수 동사를 사용합니다.",
  },
  {
    koreanChunks: ["여러 문서들이", "(과거)제출되었습니다", "어제"],
    englishChunks: ["Several documents", "were submitted", "yesterday"],
    fullEnglish: "Several documents were submitted yesterday.",
    additionalExplanation:
      "여러 문서들처럼 '여러'라는 말을 쓰고 싶을 때 Several이란 단어를 사용합니다 , 복수 주어로 was라고 하지 않고 were라고 해야 합니다.",
  },
  {
    koreanChunks: ["몇명의 고객들이", "이미 (현재)남겼습니다", "피드백을"],
    englishChunks: ["A few customers", "have already left", "feedback"],
    fullEnglish: "A few customers have already left feedback.",
    additionalExplanation:
      "복수 명사인 'customers'가 주어로 사용되었으므로 'has left'가 아니라 복수 동사 형태인 'have left'를 사용합니다. 'A few customers'는 복수 명사구로, 복수 취급되어 복수 동사를 사용합니다.",
  },
  {
    koreanChunks: ["몇몇 지원자들이", "(현재)충족합니다", "필요한 자격 요건을"],
    englishChunks: ["Few applicants", "meet", "the required qualifications"],
    fullEnglish: "Few applicants meet the required qualifications.",
    additionalExplanation:
      "셀 수 있는 몇몇을 얘기하고 싶을 때는 few를 사용합니다. 복수 주어이니 meets라고 하지 않습니다.",
  },
  {
    koreanChunks: ["많은 프로젝트들이", "현재 진행 중입니다"],
    englishChunks: ["A number of projects", "are currently in progress"],
    fullEnglish: "A number of projects are currently in progress.",
    additionalExplanation:
      "많은 것들을 이야기하고 싶을 때는 a number of, a great number of, a large number of 를 씁니다. a 가 와서 단수 아니야? 라고 생각하지 않도록 주의합니다. 마찬가지로 복수주어로 복수동사를 사용해야 합니다.",
  },
  {
    koreanChunks: ["수가 직원", "(현재)증가하는 중이다"],
    englishChunks: ["The number of employees", "is increasing"],
    fullEnglish: "The number of employees is increasing.",
    additionalExplanation:
      "'The number of'는 '~의 수'라는 의미로, 뒤에 복수 명사가 오더라도 단수 취급되어 단수 동사를 사용합니다. 따라서 'are increasing'이 아니라 'is increasing'을 사용합니다. 이는 'A number of'(많은 ~)와 다른 표현으로, 'The number of'는 '수' 자체를 가리키므로 단수로 취급됩니다.",
  },
  {
    koreanChunks: ["몇 개의 회의들이", "(현재)예정됬다", "월요일에"],
    englishChunks: [
      "A couple of meetings",
      "have been scheduled",
      "for Monday",
    ],
    fullEnglish: "A couple of meetings have been scheduled for Monday.",
    additionalExplanation:
      "셀 수 있는 몇 개, 몇몇을 표현할 때 several, a few, few, A couple of 중에 골라서 사용합니다.",
  },
  {
    koreanChunks: ["많은 불만들이", "(과거에)접수됬다", "지난 주에"],
    englishChunks: [
      "A large number of complaints",
      "were received",
      "last week",
    ],
    fullEnglish: "A large number of complaints were received last week.",
    additionalExplanation:
      "많은 것들을 이야기하고 싶을 때는 a number of, a great number of, a large number of 를 씁니다. a 가 와서 단수 아니야? 라고 생각하지 않도록 주의합니다. 마찬가지로 복수주어로 복수동사를 사용해야 합니다.많은 것들을 이야기하고 싶을 때는 a number of, a great number of, a large number of 를 씁니다. a 가 와서 단수 아니야? 라고 생각하지 않도록 주의합니다. 마찬가지로 복수주어로 복수동사를 사용해야 합니다.",
  },
  {
    koreanChunks: ["많은 수의 직원들이", "(현재)참여합니다", "교육 세션에"],
    englishChunks: [
      "A great number of employees",
      "participate in",
      "training sessions",
    ],
    fullEnglish:
      "A great number of employees participate in training sessions.",
    additionalExplanation:
      "많은 것들을 이야기하고 싶을 때는 a number of, a great number of, a large number of 를 씁니다. a 가 와서 단수 아니야? 라고 생각하지 않도록 주의합니다. 마찬가지로 복수주어로 복수동사를 사용해야 합니다.",
  },
  {
    koreanChunks: ["다양한 제품들이", "(현재)전시되어 있습니다", "앞쪽 선반에"],
    englishChunks: [
      "A variety of products",
      "are displayed",
      "on the front shelves",
    ],
    fullEnglish: "A variety of products are displayed on the front shelves.",
    additionalExplanation:
      " 'a variety of'는 '다양한 종류의'라는 의미로, 복수 명사와 함께 사용될 때 복수 취급됩니다.",
  },
  {
    koreanChunks: ["다양한 부서들이", "(현재)협력합니다", "연간 보고서에"],
    englishChunks: [
      "Various departments",
      "collaborate on",
      "the annual report",
    ],
    fullEnglish: "Various departments collaborate on the annual report.",
    additionalExplanation:
      "여러 다양한 것들을 표현할 때 'various'를 사용합니다. 'various'는 '다양한, 여러 가지의'라는 의미로, 복수 명사와 함께 사용되며 복수 동사(collaborate)를 사용합니다.",
  },
  {
    koreanChunks: ["대다수의 고객들이", "(현재)선호합니다", "온라인 결제를"],
    englishChunks: ["A majority of customers", "prefer", "online payment"],
    fullEnglish: "A majority of customers prefer online payment.",
    additionalExplanation:
      "'a majority of'는 '대다수의, 과반수의'라는 의미로, 복수 명사와 함께 사용될 때 복수 취급됩니다.",
  },
  {
    koreanChunks: ["충분한 옵션들이", "(현재)이용 가능합니다", "카탈로그에"],
    englishChunks: ["Plenty of options", "are available", "in the catalog"],
    fullEnglish: "Plenty of options are available in the catalog.",
    additionalExplanation:
      "많은 양을 표현할 때 'plenty of'를 사용합니다. 'plenty of'는 '충분한, 많은'이라는 의미로, 복수 명사와 함께 사용될 때 복수 동사(are)를 사용합니다. 이 표현은 '충분히 많은 양'이 있음을 강조하는 표현입니다.",
  },
  {
    koreanChunks: ["노인들은", "(현재)자격이 있습니다", "할인된 교통 패스에"],
    englishChunks: [
      "The elderly",
      "are eligible",
      "for discounted transportation passes",
    ],
    fullEnglish:
      "The elderly are eligible for discounted transportation passes.",
    additionalExplanation:
      "'the elderly'는 '노인들, 연장자들'을 의미하는 집합 명사로, 복수 취급되어 복수 동사(are)를 사용합니다. 특정 그룹을 지칭할 때 'the + 형용사'의 형태로 사용되며, 이는 항상 복수 취급됩니다.",
  },
  {
    koreanChunks: ["실업자들은", "(현재)제공받습니다", "무료 직업 훈련 세션을"],
    englishChunks: [
      "The unemployed",
      "are offered",
      "free job training sessions",
    ],
    fullEnglish: "The unemployed are offered free job training sessions.",
    additionalExplanation:
      "'the unemployed'는 '실업자들'을 의미하는 집합 명사로, 복수 취급되어 복수 동사(are)를 사용합니다. 'the + 형용사' 형태로 특정 그룹을 지칭할 때 사용되며, 이는 항상 복수 취급됩니다. 이 문장에서는 실업자들이라는 그룹에게 무료 직업 훈련이 제공된다는 의미입니다.",
  },
  {
    koreanChunks: [
      "장애인들은",
      "(현재)제공받습니다",
      "접근 가능한 좌석 구역을",
    ],
    englishChunks: [
      "The disabled",
      "are provided with",
      "accessible seating areas",
    ],
    fullEnglish: "The disabled are provided with accessible seating areas.",
    additionalExplanation:
      "'the disabled'는 '장애인들'을 의미하는 집합 명사로, 복수 취급되어 복수 동사(are)를 사용합니다. 'the + 형용사' 형태로 특정 그룹을 지칭할 때 사용되며, 이는 항상 복수 취급됩니다. 이 문장에서는 장애인들에게 접근 가능한 좌석 구역이 제공된다는 의미입니다.",
  },
  {
    koreanChunks: [
      "은퇴자들은",
      "종종 (현재)자원봉사합니다",
      "지역사회 프로그램에",
    ],
    englishChunks: ["The retired", "often volunteer", "in community programs"],
    fullEnglish: "The retired often volunteer in community programs.",
    additionalExplanation:
      "'the retired'는 '은퇴자들'을 의미하는 집합 명사로, 복수 취급되어 복수 동사를 사용합니다. 'the + 형용사' 형태로 특정 그룹을 지칭할 때 사용되며, 이는 항상 복수 취급됩니다. 이 문장에서는 은퇴자들이 지역사회 프로그램에서 자주 자원봉사한다는 의미입니다.",
  },
  {
    koreanChunks: ["부상자들은", "(현재)받는 중입니다 치료를", "지역병원에서"],
    englishChunks: [
      "The injured",
      "are receiving treatment",
      "at the local hospital",
    ],
    fullEnglish: "The injured are receiving treatment at the local hospital.",
    additionalExplanation:
      "'the injured'는 '부상자들'을 의미하는 집합 명사로, 복수 취급되어 복수 동사(are)를 사용합니다. 'the + 형용사' 형태로 특정 그룹을 지칭할 때 사용되며, 이는 항상 복수 취급됩니다. 이 문장에서는 부상자들이 지역 병원에서 치료를 받고 있다는 의미입니다.",
  },
  {
    koreanChunks: ["노숙자들은", "(현재)보호받는 중입니다", "추운 계절 동안"],
    englishChunks: [
      "The homeless",
      "are being sheltered",
      "during the cold season",
    ],
    fullEnglish: "The homeless are being sheltered during the cold season.",
    additionalExplanation:
      "'the homeless'는 '노숙자들'을 의미하는 집합 명사로, 복수 취급되어 복수 동사(are)를 사용합니다. 'the + 형용사' 형태로 특정 그룹을 지칭할 때 사용되며, 이는 항상 복수 취급됩니다. 이 문장에서는 노숙자들이 추운 계절 동안 보호받고 있다는 의미입니다.",
  },
  {
    koreanChunks: [
      "사람들",
      "그.. .완료한 과정을",
      "(현재)받습니다",
      "자격증을",
    ],
    englishChunks: [
      "Those",
      "who complete the course",
      "receive",
      "a certificate",
    ],
    fullEnglish: "Those who complete the course receive a certificate.",
    additionalExplanation:
      "'Those who complete the course'는 '과정을 완료한 사람들'을 의미하는 표현으로, 복수 주어이므로 복수 동사(receive)를 사용합니다. 이 문장에서는 과정을 완료한 사람들이 자격증을 받는다는 의미입니다.",
  },
  {
    koreanChunks: [
      "이 문서들은",
      "(현재)필요합니다",
      "당신의 서명을",
      "제출하기 전에",
    ],
    englishChunks: [
      "These documents",
      "require",
      "your signature",
      "before submission",
    ],
    fullEnglish: "These documents require your signature before submission.",
    additionalExplanation:
      "'These documents'는 '이 문서들'을 의미하는 복수 명사구로, 복수 주어이므로 복수 동사(require)를 사용합니다. 이 문장에서는 제출하기 전에 문서들에 서명이 필요하다는 의미입니다. 'require'는 '필요로 하다'라는 의미의 동사로, 이 문장에서는 문서가 서명을 필요로 한다는 능동적 의미로 사용되었습니다.",
  },

  {
    koreanChunks: ["하나가", "(현재)빠져있는 중입니다.", "리스트에서"],
    englishChunks: ["One", "is missing", "from the list"],
    fullEnglish: "One is missing from the list.",
    additionalExplanation:
      "'One'은 '하나'를 의미하는 단수 명사로, 단수 주어이므로 단수 동사(is)를 사용합니다.",
  },
  {
    koreanChunks: [
      "그 사람은",
      "배정된 그 과제에",
      "(현재)부재 중입니다",
      "오늘",
    ],
    englishChunks: ["The one", "assigned to the task", "is absent", "today"],
    fullEnglish: "The one assigned to the task is absent today.",
    additionalExplanation:
      "'The one'은 '그 사람'을 의미하는 단수 명사구로, 단수 주어이므로 단수 동사(is)를 사용합니다.",
  },
  {
    koreanChunks: ["또 다른 한명이", "(현재)합류했습니다", "프로젝트 팀에"],
    englishChunks: ["Another", "has joined", "the project team"],
    fullEnglish: "Another has joined the project team.",
    additionalExplanation:
      "'Another'는 '또 다른 한 명'을 의미하는 단수 명사로, 단수 주어이므로 단수 동사(has joined)를 사용합니다. .",
  },
  {
    koreanChunks: ["다른 사람들은", "(현재) 이미 완료했습니다", "양식을"],
    englishChunks: ["Others", "have already completed", "the form"],
    fullEnglish: "Others have already completed the form.",
    additionalExplanation:
      "'Others'는 '다른 사람들'을 의미하는 복수 명사로, 복수 주어이므로 복수 동사(have completed)를 사용합니다. 이 문장에서는 현재완료형을 사용하여 과거에 일어난 일이 현재까지 영향을 미치고 있음을 나타냅니다.",
  },
  {
    koreanChunks: [
      "두 명의 후보자가",
      "(과거에) 면접되었습니다.",
      "다른 한 명은",
      "예정되어 있습니다",
      "내일로",
    ],
    englishChunks: [
      "Two candidates",
      "were interviewed",
      "The other",
      "is scheduled",
      "for tomorrow",
    ],
    fullEnglish:
      "Two candidates were interviewed. The other is scheduled for tomorrow.",
    additionalExplanation:
      "'Two candidates'는 '두 명의 후보자'를 의미하는 복수 명사구로, 복수 주어이므로 복수 동사(were interviewed)를 사용합니다. 'The other'는 '다른 한 명'을 의미하는 단수 명사로, 단수 주어이므로 단수 동사(is scheduled)를 사용합니다. 첫 번째 문장은 과거시제를, 두 번째 문장은 현재시제를 사용하여 각각 과거에 일어난 일과 미래에 예정된 일을 표현합니다.",
  },
  {
    koreanChunks: [
      "대부분의 직원들이",
      "(현재)지지합니다",
      "유연한 근무 정책을",
    ],
    englishChunks: ["Most employees", "support", "the flexible work policy"],
    fullEnglish: "Most employees support the flexible work policy.",
    additionalExplanation:
      "'Most employees'는 '대부분의 직원들'을 의미하는 복수 명사구로, 복수 주어이므로 복수 동사(support)를 사용합니다.",
  },
  {
    koreanChunks: [
      "모든 문서들",
      "관련된 케이스와",
      "현재 전달됬다",
      "법무팀에",
    ],
    englishChunks: [
      "Any documents",
      "related to the case",
      "have been forwarded",
      "to legal",
    ],
    fullEnglish:
      "Any documents related to the case have been forwarded to legal.",
    additionalExplanation:
      "'Any documents'는 '모든 문서'를 의미하는 복수 명사구로, 복수 주어이므로 복수 동사(have been)를 사용합니다.",
  },
  {
    koreanChunks: ["적은 진전이", "이루어졌습니다", "추가 자금에도 불구하고"],
    englishChunks: [
      "Little progress",
      "has been made",
      "despite the additional funding",
    ],
    fullEnglish:
      "Little progress has been made despite the additional funding.",
    additionalExplanation:
      "'Little progress'는 '적은 진전'을 의미하는 단수 명사구로, 단수 주어이므로 단수 동사(has been made)를 사용합니다.",
  },
  {
    koreanChunks: ["전체 보고서가", "(현재) 검토되었습니다"],
    englishChunks: ["The entire report", "has been reviewed"],
    fullEnglish: "The entire report has been reviewed.",
    additionalExplanation:
      "'The entire report'는 '전체 보고서'를 의미하는 단수 명사구로, 단수 주어이므로 단수 동사(has been reviewed)를 사용합니다.",
  },
  {
    koreanChunks: ["모든 티켓이", "매진되었습니다", "한 시간 내에"],
    englishChunks: ["All tickets", "were sold out", "within an hour"],
    fullEnglish: "All tickets were sold out within an hour.",
    additionalExplanation:
      "All은 뒤에 오는 명사가 셀 수 있는 복수 명사일 경우, 그 복수 명사들 모두를 의미하며 복수 취급합니다. ",
  },
  {
    koreanChunks: ["모든 장비는 (현재) 보관되어 있습니다", "유지보수실에"],
    englishChunks: ["All equipment is stored", "in the maintenance room"],
    fullEnglish: "All equipment is stored in the maintenance room.",
    additionalExplanation:
      "'All은 그 다음에 오는 명사가 중요합니다. equipment'는 '모든 장비'를 의미하는 불가산 명사로, 단수 취급하므로 단수 동사(is)를 사용합니다. Equipment는 집합적 의미의 불가산 명사입니다.",
  },
  {
    koreanChunks: ["대부분의 정보는", "이미 이용 가능합니다", "온라인에서"],
    englishChunks: ["Most information", "is already available", "online"],
    fullEnglish: "Most information is already available online.",
    additionalExplanation:
      "'Most + 불가산 명사'로 단수 취급합니다. most가 대부분이라서 복수라고 생각하기보다 그 뒤에 오는 단어가 결국 불가산 명사라 단수 취급한다는 식으로 암기하면 쉽습니다.",
  },
  {
    koreanChunks: ["대부분의 지원자들은", "자격이 있습니다", "그 직책에"],
    englishChunks: ["Most applicants", "are qualified", "for the position"],
    fullEnglish: "Most applicants are qualified for the position.",
    additionalExplanation:
      "'Most applicants'는 '대부분의 지원자들'을 의미하는 복수 명사구입니다. 'applicants'가 가산 복수 명사이므로 복수 동사(are)를 사용합니다. 'Most + 가산 복수 명사'는 복수 취급합니다.",
  },
  {
    koreanChunks: ["일부 수하물이", "아직 공항에 있습니다"],
    englishChunks: ["Some luggage", "is still at the airport"],
    fullEnglish: "Some luggage is still at the airport.",
    additionalExplanation:
      "마찬가지로 some이 복수의 느낌이지만 뒤에 불가산명사가 오면 상관없이 단수가 됩니다. 'luggage'는 '수하물'을 의미하는 불가산 명사입니다. 'luggage'가 불가산 명사이므로 단수 동사(is)를 사용합니다.",
  },
  {
    koreanChunks: ["일부 고객들이", "(현재) 요청 하는 중입니다. 환불을"],
    englishChunks: ["Some clients", "are requesting refunds"],
    fullEnglish: "Some clients are requesting refunds.",
    additionalExplanation:
      " 'clients'가 가산 복수 명사이므로 복수 동사(are)를 사용합니다. 'Some + 가산 복수 명사'는 복수 취급합니다.",
  },
  {
    koreanChunks: ["어떤 조언이든", "감사합니다"],
    englishChunks: ["Any advice", "is appreciated"],
    fullEnglish: "Any advice is appreciated.",
    additionalExplanation:
      "'Any advice'는 '어떤 조언이든'을 의미하며, 'advice'는 불가산 명사입니다. 불가산 명사는 단수 취급하므로 단수 동사(is)를 사용합니다. 'Any + 불가산 명사'는 항상 단수 취급합니다.",
  },
  {
    koreanChunks: ["어떤 오류든", "자동으로 수정됩니다"],
    englishChunks: ["Any errors", "are automatically corrected"],
    fullEnglish: "Any errors are automatically corrected.",
    additionalExplanation:
      "'errors'는 가산 복수 명사입니다. 가산 복수 명사는 복수 취급하므로 복수 동사(are)를 사용합니다. 'Any + 가산 복수 명사'는 복수 취급합니다.",
  },
  {
    koreanChunks: ["많은 장비가", "구식입니다"],
    englishChunks: ["A lot of equipment", "is outdated"],
    fullEnglish: "A lot of equipment is outdated.",
    additionalExplanation:
      "'A lot of'가 많은 양을 나타내지만, 뒤에 오는 명사의 종류에 따라 동사의 형태가 결정됩니다. 'equipment'는 불가산 명사이므로 단수 동사(is)를 사용합니다. 'A lot of + 불가산 명사'는 항상 단수 취급합니다.",
  },
];
